// @flow

const Environment = {
    Development: 'development',
    Production: 'production',
    BucketName:'sureprep-developer',
    AccessKeyId:'',
    SecretAccessKey:'dSbBrRpmKGaV64fOsFaO2gKJpr3AKvgPwSwgxC9U',
    Region:'us-east-1'
};

export default Environment;
